// ✅ Müştəri profil xülasə kartı — Itemzo açıq/işıqlı stil (dark deyil).
// Yalnız real istifadəçi məlumatı. Mobile-first.
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { FaWallet, FaBoxOpen, FaHeadset, FaShieldAlt, FaCheckCircle } from 'react-icons/fa'
import AvatarBadge from './AvatarBadge'

const CustomerProfileSummary = () => {
    const navigate = useNavigate()
    const { userInfo } = useSelector(s => s.auth)
    const { balance } = useSelector(s => s.balance || {})

    const name = userInfo?.name || 'İstifadəçi'
    const email = userInfo?.email || ''
    const balanceText = typeof balance === 'number' ? balance.toFixed(2) : '0.00'

    const actions = [
        { label: 'Balans artır', icon: <FaWallet />,    to: '/dashboard/my-balance' },
        { label: 'Sifarişlərim', icon: <FaBoxOpen />,   to: '/dashboard/my-orders' },
        { label: 'Dəstək',       icon: <FaHeadset />,   to: '/support' },
        { label: 'Təhlükəsizlik',icon: <FaShieldAlt />, to: '/dashboard/security' },
    ]

    return (
        <div className='relative overflow-hidden rounded-2xl bg-white border border-slate-200 shadow-card'>
            {/* incə brend aksenti (dark blok deyil) */}
            <div className='pointer-events-none absolute -top-20 -right-16 h-44 w-44 rounded-full bg-brand-100/70 blur-2xl' />

            {/* desktop-first config: base=desktop, md=≤768 mobil */}
            <div className='relative p-6 md:p-4'>
                {/* üst: avatar + ad + balans (mobil: sütun) */}
                <div className='flex items-center gap-4 md:flex-col md:items-stretch'>
                    <div className='flex items-center gap-4 min-w-0 flex-1'>
                        <AvatarBadge avatarId={userInfo?.avatarId} size='lg' />
                        <div className='min-w-0 flex-1'>
                            <h2 className='text-xl md:text-lg font-black text-slate-900 truncate'>{name}</h2>
                            <p className='text-sm text-slate-500 truncate'>{email}</p>
                            <div className='mt-1.5 flex items-center gap-2 flex-wrap'>
                                <span className='inline-flex items-center gap-1 rounded-full bg-emerald-50 px-2.5 py-0.5 text-xs font-bold text-emerald-700 border border-emerald-200'>
                                    <FaCheckCircle size={10} /> Aktiv hesab
                                </span>
                                <span className='inline-flex items-center rounded-full bg-brand-50 px-2.5 py-0.5 text-xs font-semibold text-brand-700 border border-brand-100'>
                                    Itemzo üzvü
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* balans — desktopda sağda, mobildə tam en */}
                    <div className='ml-auto md:ml-0 md:w-full rounded-xl bg-gradient-to-br from-brand-50 to-indigo-50 border border-brand-100 px-5 py-3 text-right flex items-center justify-between md:gap-3'>
                        <p className='text-[11px] uppercase tracking-wider text-brand-600 font-bold'>Balans</p>
                        <p className='text-2xl font-black text-slate-900 leading-none'>{balanceText} <span className='text-brand-600'>₼</span></p>
                    </div>
                </div>

                {/* sürətli əməliyyatlar — desktop 4 sütun, mobil 2 */}
                <div className='mt-4 grid grid-cols-4 sm:grid-cols-2 gap-2.5'>
                    {actions.map(a => (
                        <button
                            key={a.to + a.label}
                            onClick={() => navigate(a.to)}
                            className='flex items-center justify-center gap-2 rounded-xl bg-slate-50 hover:bg-brand-50 border border-slate-200 hover:border-brand-200 px-3 py-2.5 text-sm font-semibold text-slate-700 hover:text-brand-700 transition-colors'
                        >
                            <span className='text-brand-600'>{a.icon}</span>
                            <span className='truncate'>{a.label}</span>
                        </button>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default CustomerProfileSummary
